import type SortDirection from '$shared/constants/SortDirection';
import type { IPageRes } from '$shared/interfaces/api/IPageRes';

export class PageRes<C, I = any> {
  public previousCursor: string;
  public nextCursor: string;
  public pageSize: number;
  public count: number;
  public totalCount: number;
  public items: C[];
  public sortedBy: string;
  public sortDirection: string;

  constructor(response: IPageRes<I>) {
    this.previousCursor = response?.previousCursor || '';
    this.nextCursor = response?.nextCursor || '';
    this.pageSize = response?.pageSize;
    this.count = response?.count;
    this.totalCount = response?.totalCount;
    this.sortedBy = response?.sortedBy;
    this.sortDirection = response?.sortDirection as SortDirection;
  }

  static create<C, I>(response: IPageRes<I>, callback: (data: I) => C): PageRes<C, I> {
    const listResponse = new PageRes<C, I>(response);
    listResponse.items = response?.items?.map((item) => callback(item)) || [];
    return listResponse;
  }

  static createEmpty<C, I>(): PageRes<C, I> {
    const emptyList = new PageRes<C, I>({
      previousCursor: '',
      nextCursor: '',
      pageSize: 0,
      count: 0,
      totalCount: 0,
      items: [],
      sortedBy: '',
      sortDirection: ''
    });
    emptyList.items = [];
    return emptyList;
  }
}
